import { useEffect, useState } from 'react';
import { Link } from "@/helpers/common_helper";
import { _postURL } from "@/api/index";
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper';
import { useMediaQuery } from '@mantine/hooks';
import _ from 'lodash';

export default function ArticleBonusMobile(props) {
    const currency_label = 'MYR';
    const [latestBonusList, setLatestBonusList] = useState([]);
    const isMobileView = useMediaQuery('(max-width:1199px)');

    useEffect(async () => {
        if(isMobileView){
            try {
                let bonus = await _postURL("/api/home/getLatestBonus", {});  // Get Latest Bonus
                if(!_.isEmpty(bonus.data)){
                    setLatestBonusList(bonus.data.data);
                }
            }
            catch (error) {
                console.log(error);
            }
        }
    }, [isMobileView]);

    return (
        <>
            {!isMobileView ? null :
                <div className="article-latest-bonus-mobile">
                    {_.isEmpty(latestBonusList) ? null : 
                        <Swiper
                            modules={[Autoplay, Navigation]}
                            slidesPerView={1}
                            loop={true}
                            autoplay={{
                                delay: 3000
                            }}
                            navigation={{
                                nextEl: ".swiper-button-next2",
                                prevEl: ".swiper-button-prev2",
                            }}
                            style={{
                                maxWidth: '520px',
                                width: '100%'
                            }}
                        >
                            <div className="swiper-wrapper">
                                {
                                    _.reduce(latestBonusList, (result, value, key) => {
                                        result.push(
                                            <SwiperSlide key={key}>
                                                <div className="article-latest-bonus-mobile-box">
                                                    <div className={"article-latest-bonus-mobile-inner article-latest-bonus-mobile-box-"+value.text_color}>
                                                        <div className="article-latest-bonus-mobile-top">
                                                            <div className="article-latest-bonus-mobile-logo">
                                                                <img className="img-fluid w-100" alt="" src={process.env.NEXT_PUBLIC_FS_URL+value.logo} />
                                                            </div>
                                                            <div className={"article-latest-bonus-mobile-title article-latest-bonus-text-"+value.text_color}>{value.bonus_title}</div>
                                                        </div>
                                                        <div className="article-latest-bonus-mobile-bottom">
                                                            <div className="">Casino Profit:</div>
                                                            <div className={"article-latest-bonus-text-"+value.text_color}>{currency_label}{value.company_profit}</div>
                                                            <div className="article-latest-bonus-mobile-button-sec">
                                                                <Link href={value.cta_link}>
                                                                    <a target="_blank">
                                                                        <button className="article-latest-bonus-mobile-button">View More</button>
                                                                    </a>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </SwiperSlide>
                                        )
                                        return result;
                                    }, [])
                                }
                            </div>
                            <div className="swiper-button-prev swiper-button-prev2"></div>
                            <div className="swiper-button-next swiper-button-next2"></div>
                        </Swiper>
                    }
                </div>
            }
        </>
    )
}